import React from 'react'
import FormFieldProps, { FormFieldType, isFormFieldProp, isFormFields } from '@App/forms/v2/common/form-field'
import FormFieldFromProps from '@App/kit/fields/v2/FormFieldFromProps'
import { FieldValidationDependency } from '@App/common/types/FieldValidationDependency'

interface InnerFormProps {
    formFields: FormFieldType<unknown>
    fieldValidationDependencies?: FieldValidationDependency
}

const InnerForm = ({ formFields, fieldValidationDependencies }: InnerFormProps) => {
    const fieldHasValidationDependency = (formField: FormFieldProps) =>
        fieldValidationDependencies?.find((dep) => (dep.dependOn as FormFieldProps).name === formField.name)
            ?.dependencies

    return (
        <>
            {isFormFields(formFields) &&
                Object.values(formFields).map((formField) => {
                    if (isFormFieldProp(formField)) {
                        const foundDependencies = fieldHasValidationDependency(formField)
                        if (foundDependencies && foundDependencies.length > 0) {
                            return (
                                <FormFieldFromProps
                                    field={formField}
                                    key={formField.name}
                                    validationDependency={foundDependencies as FormFieldProps[]}
                                />
                            )
                        } else {
                            return <FormFieldFromProps field={formField} key={formField.name} />
                        }
                    } else {
                        return null
                    }
                })}
        </>
    )
}

export default InnerForm
